<div
  *transloco="let t"
  class="flex h-full flex-col space-y-1 rounded bg-white p-6 text-xs md:p-4 2xl:p-6 2xl:text-sm"
>
  <span class="mb-3 text-xs font-bold 2xl:text-base">{{
    title
  }}</span>

  <ng-container *ngIf="data && data.length > 0; else noCases">
    <ng-container *ngFor="let item of data; let i = index">
      <div
        [class.border-b-mbaza-gray-light]="i !== data.length - 1"
        [class.border-b]="i !== data.length - 1"
        class="flex items-center py-3"
      >
        <span class="w-6 text-center">{{ i + 1 }}</span>
        <img [src]="imgSrc" alt="icon" class="w-4 h-4 mr-2" />
        <span class="flex-1 font-medium">
          {{
            item.name.length > 17
              ? (item.name | slice: 0 : 17) + "..."
              : item.name
          }}</span
        >
        <span class="font-bold">{{ item.value | number }}</span>
        <span class="ml-1 text-gray-500">{{ valueLabel }}</span>
      </div>
    </ng-container>
  </ng-container>

  <ng-template #noCases>
    <div class="flex items-center justify-start">
      <span class="text-gray-500">{{ t("noCasesFound") }}</span>
    </div>
  </ng-template>
</div>
